import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Contact = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.iubenda.com/iubenda.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section className="contact py-80">
      {/* ✅ Page-only styling */}
      <style>{`
        .contact h1,
        .contact h2,
        .contact h3,
        .contact h4,
        .contact h5,
        .contact h6 {
          font-size: 28px;
          margin-top: 20px;
          margin-bottom: 20px;
        }
      `}</style>
      <div className="container container-lg">
        <div className="row gy-5">
          <div className="col-lg-12">
            <div className="contact-box px-24 py-40">
              <a
                href="https://www.iubenda.com/terms-and-conditions/25051591"
                className="iubenda-white iubenda-noiframe iubenda-embed iub-legal-only iub-no-markup iubenda-noiframe iub-body-embed"
                title="Terms and Conditions"
              >
                Terms and Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
